// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/escat-plan.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/escat-plan/escat-plan.js';

mount([g0]);
